import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate, translate} from 'views/module';

const CaregiverEditStatus = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldStatus = oldData.status;
  const newStatus = newData.status;

  let oldStatusTitle = translate(`caregiver.Status.${oldStatus}.Title`);
  if (oldStatusTitle === 'Missing translation') {
    oldStatusTitle = oldStatus;
  }
  let newStatusTitle = translate(`caregiver.Status.${newStatus}.Title`);
  if (newStatusTitle === 'Missing translation') {
    newStatusTitle = newStatus;
  }

  return (
    <Stack>
      <Translate
        expression='caregiver.CaregiverDetail.Correspondance.Logs.EditStatus.Text'
        substitute={{
          oldStatus: oldStatusTitle,
          newStatus: newStatusTitle,
        }}
      />
    </Stack>
  );
};
CaregiverEditStatus.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(CaregiverEditStatus);
